import React from 'react';
import { truncate, truncateHTML } from '@utils/Truncate';
import SvgSafeGatsbyImage from '@atoms/SvgSafeGatsbyImage';
import Link from "../primitives/link";
import { colors } from '../primitives/colors';
import IconArrow from '../../images/svg/arrow-forward.svg';
import { justPTags } from '../utils/just-p-tags';

const ArticleBlock = ({ isIndex, withImage, article, isMultiBlogroll }) => {
  const { featured_image, title, content, url } = article
  const truncatedTitle = truncate(title, 100)
  // eslint-disable-next-line no-nested-ternary
  const truncatedContent = content
    ? isMultiBlogroll
      ? truncateHTML(justPTags(content), 90)
      : truncateHTML(justPTags(content), 400)
    : 'no content'

    return (
        <div css={styles.articleContainer(isIndex)}>
            {featured_image?.url && withImage && (
                <div css={styles.cardImageContainer}>
                    <SvgSafeGatsbyImage css={styles.cardImage} image={featured_image} alt={featured_image.description} />
                </div>
            )}
            <div>
                <h3 css={styles.articleTitle}>
                    <Link to={url}>{truncatedTitle}</Link>
                </h3>
                <div
                    css={styles.articleContent}
                    dangerouslySetInnerHTML={{
                        __html: truncatedContent
                    }}
                />
                {url && !isIndex && (
                    <Link css={styles.articleLink} to={url}>Read More <IconArrow css={styles.forwardArrow} />
                    </Link>
                )}
            </div>
        </div>
    );
};

const styles = {
    cardImageContainer: {
        position: "relative",
        marginBottom: "1rem",
        marginLeft: "auto",
        marginRight: "auto",
        minWidth: "100%",
        flexShrink: 0,
        "::before": {
            display: "block",
            paddingTop: "63%",
            content: "''",
        },
        "@media (min-width: 1024px)": {
            marginLeft: "0",
            marginRight: "2.25rem",
            minWidth: "340px",
        }
    },
    articleContainer: (isIndex) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        borderBottom: "1px solid rgba(202, 202, 202, 1)",
        paddingTop: "1rem",
        paddingBottom: !isIndex && "1rem",
        "@media (min-width: 1024px)": {
            flexDirection: "row"
        }
    }),
    cardImage: {
        objectFit: "cover",
        objectPosition: "center",
        marginBottom: "1rem",
        position: "absolute !important",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
    },
    articleTitle: {
        fontSize: "1.25rem",
        lineHeight: "1.75rem",
        color: colors.primaryOrange,
        marginBottom: "8px",
        lineHeight: 1.16,
    },
    articleContent: {
        marginBottom: "24px",
        fontSize: "18px",
        lineHeight: 1.2,
    },
    articleLink: {
        display: "flex",
        alignItems: "center",
        fontWeight: 600
    },
    forwardArrow: {
        marginLeft: "0.25rem"
    }
};

export default ArticleBlock;